interface ValidateProps {
  value: unknown;
  validators: any[];
  validatorProps?: {
    maxFileSize: number;
    allowedExtensions: string[];
    fileTypeLabel: string;
  };
  language: string;
}

export const validate = async ({
  value,
  validators,
  validatorProps,
  language,
}: ValidateProps) => {
  const invalidValidators = validators.filter(
    ({ test }) => !test({ value, validatorProps }),
  );

  if (!invalidValidators[0]) {
    return '';
  }

  return invalidValidators[0].getErrorMessage(
    { value, validatorProps },
    language,
  );
};
